<dialog id="dialogElement" #dialogElement [ngClass]="'size-' + size" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <ng-content select="[content]"></ng-content>
</dialog>
